// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AbRmM","top":"styles_top__2KBUM","left":"styles_left__2y9V2","description":"styles_description__1Hhcg"};